import { combineReducers } from 'redux';
import settings from './settings/reducer';
import menu from './menu/reducer';
import authUser from './auth/reducer';
import role from './role/reducer';

const reducers = combineReducers({
  menu,
  settings,
  authUser,
  role
});

export default reducers;
